// extracted by mini-css-extract-plugin
module.exports = {"search-input-sm":"styles-module__search-input-sm___2wiEY"};